<div style="margin-left: 4%; margin-right: 4%">
  @if (displayRevisionNumber > 0) {
    <div>
      <div style="margin-top: 2.625rem; display: inline-block">
        <span class="itProjectHeader" style="font-size: 1.313rem"
          >Form #{{ formNumber }}, Rev {{ displayRevisionNumber }}</span
        >
      </div>
      <div style="display: inline-block; margin-top: 2.625rem; float: right">
        <button class="confirmButton" (click)="submitForm()">
          <span class="confirmText">SUBMIT</span>
        </button>
      </div>
      <div
        style="display: inline-block; margin-top: 2.625rem; float: right; margin-right: 0.875rem"
      >
        <div class="exitButton" (click)="goToSetupPage()">
          <span class="exitText">EDIT FORM</span>
        </div>
      </div>
      <div
        style="display: inline-block; float: right; margin-right: 0.875rem; margin-top: 2.625rem"
      >
        <div class="exitButton" (click)="saveDraft()">
          <span class="exitText">SAVE DRAFT</span>
        </div>
      </div>
    </div>
  }
  <div style="display: inline-block; margin-top: 2.625rem">
    <span class="itProjectHeader">Accounting Request Form: Review</span>
    <div style="display: inline-block; cursor: pointer" (click)="goToSetupPage()">
      <img style="width: 1.438rem; margin-left: 0.625rem" src="assets/review-edit.svg" />
      <span style="text-decoration: underline; text-underline-offset: 0.15rem">Edit</span>
    </div>
  </div>
  @if (draftSaved) {
    <div style="display: inline-block; margin-top: 2.625rem">
      <div
        style="
          display: inline-block;
          margin-left: 1rem;
          background: #d7d9da 0% 0% no-repeat padding-box;
          border-radius: 8px;
          opacity: 1;
          width: 3.438rem;
          text-align: center;
        "
      >
        <span style="color: #4c4c4c; font-size: 0.875rem">Draft</span>
      </div>
      <div style="display: inline-block; margin-left: 1rem">
        <span style="color: #4c4c4c; font-size: 0.75rem; font-style: italic"
          >Saved {{ draftSavedTime }} on {{ draftSavedDay }}</span
        >
      </div>
    </div>
  }
  @if (displayRevisionNumber === 0) {
    <div style="display: inline-block; margin-top: 2.625rem; float: right">
      <button class="confirmButton" (click)="submitForm()">
        <span class="confirmText">SUBMIT</span>
      </button>
    </div>
  }
  @if (displayRevisionNumber === 0) {
    <div style="display: inline-block; margin-top: 2.625rem; float: right; margin-right: 0.875rem">
      <div class="exitButton" (click)="goToSetupPage()">
        <span class="exitText">EDIT FORM</span>
      </div>
    </div>
  }
  @if (displayRevisionNumber === 0) {
    <div style="display: inline-block; float: right; margin-right: 0.875rem; margin-top: 2.625rem">
      <div class="exitButton" (click)="saveDraft()">
        <span class="exitText">SAVE DRAFT</span>
      </div>
    </div>
  }
  <div style="margin-top: 2.625rem">
    <span class="itProjectHeader" style="font-size: 1.313rem">Page One</span>
    <div style="display: inline-block; cursor: pointer" (click)="goToSetupPage()">
      <img style="width: 1.438rem; margin-left: 0.625rem" src="assets/review-edit.svg" />
      <span style="text-decoration: underline; text-underline-offset: 0.15rem">Edit</span>
    </div>
  </div>
  <div style="margin-top: 1.5rem; display: flex">
    <div style="width: 34rem; height: 6.25rem">
      <div style="display: inline-block; margin-top: 1.125rem">
        <mat-form-field class="itFields" style="width: 30rem">
          <input
            matInput
            readonly="true"
            placeholder="PaTI ID #"
            [(ngModel)]="displayPatiProject"
          />
        </mat-form-field>
      </div>
    </div>
  </div>
  <div style="display: flex">
    <div style="margin-top: 1.5rem">
      <div style="width: 23.438rem; height: 6.25rem">
        <div style="display: inline-block; margin-top: 1.125rem">
          <mat-form-field class="itFields" style="width: 19.4rem" [floatLabel]="'always'">
            <input
              maxlength="35"
              readonly="true"
              [(ngModel)]="projectName"
              placeholder="Short Description (Max 35 Characters)"
              matInput
            />
          </mat-form-field>
        </div>
      </div>
    </div>
    <div style="display: inline-block; margin-top: 1.5rem">
      <div style="width: 23.438rem; height: 6.25rem">
        <div style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem">
          <mat-form-field class="itFields" style="width: 19.4rem">
            <input
              placeholder="IT Project Classification"
              readonly="true"
              matInput
              [(ngModel)]="itProjectClassification.ets_proj_classification"
            />
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
  <div style="margin-top: 1.5rem; margin-right: 1.5rem">
    <div style="width: 48.375rem; height: 6.25rem">
      <mat-form-field
        style="
          background: white;
          padding-right: 1.5rem;
          margin-top: 1.125rem;
          width: 21.438rem;
          height: 4rem;
        "
      >
        <mat-label>Estimated Start Date</mat-label>
        <input
          matInput
          readonly="true"
          #datepickerInput1
          [matDatepicker]="startDatePicker"
          [(ngModel)]="estimatedStartDate"
          style="color: #696969"
        />
        <mat-datepicker #startDatePicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field
        style="
          background: white;
          padding-left: 0.4rem;
          padding-right: 0.4rem;
          margin-left: 1.5rem;
          width: 21.438rem;
          height: 4rem;
        "
      >
        <mat-label>Estimated In Service Date</mat-label>
        <input
          matInput
          readonly="true"
          #datepickerInput2
          [matDatepicker]="inServiceDatePicker"
          [(ngModel)]="estimatedInServiceDate"
          style="color: #696969"
        />
        <mat-datepicker #inServiceDatePicker></mat-datepicker>
      </mat-form-field>
    </div>
  </div>
  <div style="margin-top: 1.5rem">
    <span class="projectScopeHeader">Overview and Scope</span>
  </div>
  <div style="margin-top: 0.688rem">
    <textarea
      readonly="true"
      [(ngModel)]="projectScopeDescription"
      class="scopeDescriptionTextBox"
      maxlength="255"
    ></textarea>
  </div>
  <div style="margin-top: 1.5rem">
    <span class="projectScopeHeader">Contacts</span>
  </div>
  <div style="margin-top: 0.688rem">
    <div style="width: 66.375rem; height: 6.25rem">
      <mat-form-field class="itFields" style="margin-top: 1.125rem; width: 55.638rem; height: 4rem">
        <input
          readonly="true"
          name="primaryContact"
          type="text"
          placeholder="Primary Contact"
          matInput
          [(ngModel)]="displayPrimaryContact"
        />
      </mat-form-field>
    </div>
  </div>
  <div style="margin-top: 0.688rem">
    <div style="width: 66.375rem; height: 6.25rem">
      <mat-form-field class="itFields" style="margin-top: 1.125rem; width: 55.638rem; height: 4rem">
        <input
          readonly="true"
          name="itSponsor"
          type="text"
          placeholder="Sponsor"
          matInput
          [(ngModel)]="displayItSponsor"
        />
      </mat-form-field>
    </div>
  </div>
  <div style="width: fit-content">
    <div style="display: flex; gap: 1rem; color: dimgray; background-color: white">
      <span>Is this request O&M only?</span>
      <mat-radio-group [(ngModel)]="omOnly" required name="omOnlyField" disabled>
        <mat-radio-button color="primary" [value]="'YES'">
          <span class="choiceText">YES</span>
        </mat-radio-button>
        <mat-radio-button color="primary" [value]="'NO'" style="margin-left: 1.125rem">
          <span class="choiceText">NO</span>
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
  <div style="margin-top: 1.5rem">
    <div style="width: 24.438rem; height: 6.25rem">
      <div style="display: inline-block; margin-top: 1.125rem">
        <mat-form-field class="itFields" style="width: 20.4rem">
          <input
            readonly="true"
            type="text"
            placeholder="Does this work relate to:"
            matInput
            [(ngModel)]="relatedWork"
          />
        </mat-form-field>
      </div>
    </div>
  </div>
  @if (hardwareOrSoftware === 'Hardware Only' || hardwareOrSoftware === 'Hardware and Software') {
    <div>
      <div style="margin-top: 1.5rem">
        <span class="projectScopeHeader">Hardware Details</span>
      </div>
      <div style="margin-top: 0.688rem">
        <div style="width: 73.25rem">
          <div style="position: relative">
            <div
              style="
                display: inline-block;
                margin-top: 1.5rem;
                margin-bottom: 1.5rem;
                width: 34.438rem;
              "
            >
              <span class="bodyText"
                >Are you purchasing any service warranties? (If yes, the cost of service warranties
                should be included in O&M estimate; none of this cost can be capitalized)</span
              >
            </div>
            <div
              style="
                display: inline-block;
                margin-top: 1.5rem;
                margin-left: 7.375rem;
                vertical-align: top;
                position: absolute;
                top: 0.625rem;
              "
            >
              <mat-radio-group [(ngModel)]="purchasingWarranties" disabled>
                <mat-radio-button color="primary" [value]="'YES'">
                  <span class="choiceText">YES</span>
                </mat-radio-button>
                <mat-radio-button color="primary" [value]="'NO'" style="margin-left: 1.125rem">
                  <span class="choiceText">NO</span>
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  @if (hardwareOrSoftware === 'Software Only' || hardwareOrSoftware === 'Hardware and Software') {
    <div>
      <div style="margin-top: 1.5rem">
        <span class="projectScopeHeader">Software Details</span>
      </div>
      <div style="margin-top: 0.688rem">
        <div style="width: 73.25rem">
          <div style="padding-top: 1rem">
            <span style="color: gray">Work consists of the following: (Select all that apply)</span>
            @for (option of projectConsistsOfOptions; track option; let i = $index) {
              <div style="text-align: left; margin-bottom: 0.938rem">
                <mat-checkbox color="primary" disabled [checked]="projectConsistsOfCheckboxes[i]">
                  <span style="color: #696969; white-space: normal">{{ option }}</span>
                </mat-checkbox>
              </div>
            }
          </div>
          <div>
            <div style="display: inline-block; margin-top: 1.5rem">
              <mat-form-field class="itFields" style="width: 20.4rem" [floatLabel]="'always'">
                <input
                  readonly="true"
                  type="text"
                  [(ngModel)]="expectedLife"
                  placeholder="What is the expected life of the software (years)?"
                  matInput
                />
              </mat-form-field>
            </div>
          </div>
          <div style="position: relative">
            <div style="display: inline-block; margin-top: 1.5rem; width: 34.438rem">
              <span class="bodyText">Is this an Agile effort?</span>
            </div>
            <div
              style="
                display: inline-block;
                margin-top: 1.5rem;
                margin-left: 7.375rem;
                vertical-align: top;
                position: absolute;
                top: 0.625rem;
              "
            >
              <mat-radio-group [(ngModel)]="agileEffort" disabled>
                <mat-radio-button color="primary" [value]="'YES'">
                  <span class="choiceText">YES</span>
                </mat-radio-button>
                <mat-radio-button color="primary" [value]="'NO'" style="margin-left: 1.125rem">
                  <span class="choiceText">NO</span>
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          <div style="position: relative">
            <div style="display: inline-block; margin-top: 1.5rem; width: 34.438rem">
              <span class="bodyText"
                >Does the software currently exist or is it being used for any other jurisdictions,
                department, business unit, or function?</span
              >
            </div>
            <div
              style="
                display: inline-block;
                margin-top: 1.5rem;
                margin-left: 7.375rem;
                vertical-align: top;
                position: absolute;
                top: 0.625rem;
              "
            >
              <mat-radio-group [(ngModel)]="softwareBeingUsed" disabled>
                <mat-radio-button color="primary" [value]="'YES'">
                  <span class="choiceText">YES</span>
                </mat-radio-button>
                <mat-radio-button color="primary" [value]="'NO'" style="margin-left: 1.125rem">
                  <span class="choiceText">NO</span>
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          <div>
            <div style="display: inline-block; margin-top: 1.5rem">
              <mat-form-field class="itFields" style="width: 19.4rem">
                <input
                  readonly="true"
                  [(ngModel)]="vendorName"
                  placeholder="Vendor Name (Optional)"
                  matInput
                />
              </mat-form-field>
            </div>
            <div style="display: inline-block; margin-top: 1.5rem; margin-left: 1.5rem">
              <mat-form-field class="itFields" style="width: 19.4rem">
                <input
                  readonly="true"
                  [(ngModel)]="softwareName"
                  placeholder="Software Name"
                  matInput
                />
              </mat-form-field>
            </div>
            <div
              [class.hideText]="softwareBeingUsed === 'NO'"
              style="display: inline-block; margin-top: 1.5rem; margin-left: 1.5rem"
            >
              <mat-form-field class="itFields" style="width: 19.4rem">
                <input
                  readonly="true"
                  [(ngModel)]="inServiceYear"
                  placeholder="In what year did it go in service?"
                  matInput
                />
              </mat-form-field>
            </div>
          </div>
          <div style="margin-top: 1.5rem">
            <span class="bodyText"
              >Describe the software development work needed for this effort:</span
            >
          </div>
          <div style="margin-top: 0.688rem">
            <textarea
              [(ngModel)]="softwareProjectOverview"
              class="softwareProjectOverviewTextBox"
              style="height: 4rem; width: 45.375rem"
            ></textarea>
          </div>
          <div style="width: 49.438rem">
            <div style="display: inline-block; margin-top: 1.5rem; width: 37.688rem">
              <span class="bodyText"
                >Will you have data conversion activities? (If yes, the cost of running processes or
                manually cleaning up data should be included in O&M estimate; only development of
                data conversion software can be capitalized)</span
              >
            </div>
            <div
              style="display: inline-block; margin-top: 1.5rem; vertical-align: top; float: right"
            >
              <mat-radio-group [(ngModel)]="dataConversionActivities" disabled>
                <mat-radio-button color="primary" [value]="'YES'">
                  <span class="choiceText">YES</span>
                </mat-radio-button>
                <mat-radio-button color="primary" [value]="'NO'" style="margin-left: 1.125rem">
                  <span class="choiceText">NO</span>
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          <div style="width: 49.438rem">
            <div style="display: inline-block; margin-top: 1.5rem; width: 37.688rem">
              <span class="bodyText"
                >Will you have training costs? (If yes, the cost of train-the-trainer and user
                training should be included in O&M estimate; only developer training on how to
                develop the software can be capitalized)</span
              >
            </div>
            <div
              style="display: inline-block; margin-top: 1.5rem; vertical-align: top; float: right"
            >
              <mat-radio-group [(ngModel)]="trainingCosts" disabled>
                <mat-radio-button color="primary" [value]="'YES'">
                  <span class="choiceText">YES</span>
                </mat-radio-button>
                <mat-radio-button color="primary" [value]="'NO'" style="margin-left: 1.125rem">
                  <span class="choiceText">NO</span>
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          <div style="width: 49.438rem">
            <div style="display: inline-block; margin-top: 1.5rem; width: 37.688rem">
              <span class="bodyText">Is there an associated retirement of existing software?</span>
            </div>
            <div
              style="display: inline-block; margin-top: 1.5rem; vertical-align: top; float: right"
            >
              <mat-radio-group [(ngModel)]="associatedRetirement" disabled>
                <mat-radio-button color="primary" [value]="'YES'">
                  <span class="choiceText">YES</span>
                </mat-radio-button>
                <mat-radio-button color="primary" [value]="'NO'" style="margin-left: 1.125rem">
                  <span class="choiceText">NO</span>
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          <div [class.hideElements]="associatedRetirement !== 'YES'" style="display: inline-block">
            <div style="display: inline-block; margin-top: 0.688rem">
              <mat-form-field class="itFields" style="width: 19.4rem">
                <input
                  readonly="true"
                  [(ngModel)]="softwareToBeRetired"
                  placeholder="Software To Be Retired"
                  matInput
                />
              </mat-form-field>
            </div>
            <div style="display: inline-block; margin-top: 0.688rem; margin-left: 1.5rem">
              <mat-form-field class="itFields" style="width: 19.4rem">
                <input
                  readonly="true"
                  [(ngModel)]="retiredInServiceDate"
                  placeholder="When was it in service?"
                  matInput
                />
              </mat-form-field>
            </div>
          </div>
          <div style="width: 49.438rem">
            <div style="display: inline-block; margin-top: 1.5rem; width: 37.688rem">
              <span class="bodyText">Will you have any maintenance contracts/agreements?</span>
            </div>
            <div
              [class.moveDown]="associatedRetirement === 'YES'"
              style="
                display: inline-block;
                margin-top: 1.5rem;
                vertical-align: top;
                float: right;
                position: relative;
                top: -3.313rem;
              "
            >
              <mat-radio-group [(ngModel)]="maintenanceContracts" disabled>
                <mat-radio-button color="primary" [value]="'YES'">
                  <span class="choiceText">YES</span>
                </mat-radio-button>
                <mat-radio-button color="primary" [value]="'NO'" style="margin-left: 1.125rem">
                  <span class="choiceText">NO</span>
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          <div style="width: 49.438rem">
            <div style="display: inline-block; margin-top: 1.5rem; width: 37.688rem">
              <span class="bodyText">Are you replacing any existing interfaces?</span>
            </div>
            <div
              [class.moveLeft]="associatedRetirement === 'YES'"
              style="
                display: inline-block;
                margin-top: 1.5rem;
                vertical-align: top;
                float: right;
                position: relative;
                top: -3.313rem;
                left: 7.48rem;
              "
            >
              <mat-radio-group [(ngModel)]="replacingInterfaces" disabled>
                <mat-radio-button color="primary" [value]="'YES'">
                  <span class="choiceText">YES</span>
                </mat-radio-button>
                <mat-radio-button color="primary" [value]="'NO'" style="margin-left: 1.125rem">
                  <span class="choiceText">NO</span>
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          <div>
            <mat-form-field
              class="itFields"
              style="margin-top: 1.5rem; margin-bottom: 1.5rem; width: 30.938rem"
            >
              <input
                readonly="true"
                type="text"
                placeholder="How will the software be released?"
                matInput
                [(ngModel)]="howSoftwareReleased"
              />
            </mat-form-field>
          </div>
          @if (isVendorHosted()) {
            <div style="width: 49.438rem">
              <div style="display: inline-block; width: 37.688rem">
                <span class="bodyText">Will Duke own perpetual licenses?</span>
              </div>
              <div
                style="display: inline-block; vertical-align: top; float: right; position: relative"
              >
                <mat-radio-group [(ngModel)]="perpetualLicenses" disabled>
                  <mat-radio-button color="primary" [value]="'YES'">
                    <span class="choiceText">YES</span>
                  </mat-radio-button>
                  <mat-radio-button color="primary" [value]="'NO'" style="margin-left: 1.125rem">
                    <span class="choiceText">NO</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          }
          @if (isVendorHosted()) {
            <div style="width: 49.438rem">
              <div style="display: inline-block; margin-top: 1.5rem; width: 36.688rem">
                <span class="bodyText"
                  >Does Duke have the contractual right to take possession of the software at any
                  time during the arrangement period?</span
                >
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  vertical-align: top;
                  float: right;
                  position: relative;
                  top: -3.313rem;
                "
              >
                <mat-radio-group [(ngModel)]="contractualRight" disabled>
                  <mat-radio-button color="primary" [value]="'YES'">
                    <span class="choiceText">YES</span>
                  </mat-radio-button>
                  <mat-radio-button color="primary" [value]="'NO'" style="margin-left: 1.125rem">
                    <span class="choiceText">NO</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          }
          @if (isVendorHosted()) {
            <div style="width: 49.438rem">
              <div style="display: inline-block; margin-top: 1.5rem; width: 37.688rem">
                <span class="bodyText"
                  >Is there a significant penalty to take possession of the software and bring it in
                  house? (Significant penalty is interpreted as either a significant cost or
                  significant reduction in value or functionality when taking possession of the
                  software. Significant cost is defined as greater than 15% of the total capital
                  cost of the project)</span
                >
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  vertical-align: top;
                  float: right;
                  position: relative;
                  top: -6.313rem;
                "
              >
                <mat-radio-group [(ngModel)]="significantPenalty" disabled>
                  <mat-radio-button color="primary" [value]="'YES'">
                    <span class="choiceText">YES</span>
                  </mat-radio-button>
                  <mat-radio-button color="primary" [value]="'NO'" style="margin-left: 1.125rem">
                    <span class="choiceText">NO</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          }
          @if (isVendorHosted()) {
            <div style="width: 49.438rem">
              <div style="display: inline-block; margin-top: 1.5rem; width: 34.688rem">
                <span class="bodyText"
                  >Is it feasible for Duke to run the software on our own hardware or to contract
                  with another third party host?</span
                >
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 0.5rem;
                  vertical-align: top;
                  float: right;
                  position: relative;
                  top: -3.313rem;
                "
              >
                <mat-radio-group [(ngModel)]="isFeasible" disabled>
                  <mat-radio-button color="primary" [value]="'YES'">
                    <span class="choiceText">YES</span>
                  </mat-radio-button>
                  <mat-radio-button color="primary" [value]="'NO'" style="margin-left: 1.125rem">
                    <span class="choiceText">NO</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          }
          @if (isVendorHosted()) {
            <div style="width: 49.438rem">
              <div style="display: inline-block; margin-top: 1.5rem; width: 37.688rem">
                <span class="bodyText">Are there service or usage fees?</span>
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  vertical-align: top;
                  float: right;
                  position: relative;
                  top: -3.313rem;
                "
              >
                <mat-radio-group [(ngModel)]="serviceFees" disabled>
                  <mat-radio-button color="primary" [value]="'YES'">
                    <span class="choiceText">YES</span>
                  </mat-radio-button>
                  <mat-radio-button color="primary" [value]="'NO'" style="margin-left: 1.125rem">
                    <span class="choiceText">NO</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          }
          @if (isVendorHosted()) {
            <div style="width: 49.438rem">
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  margin-bottom: 1.5rem;
                  width: 37.688rem;
                "
              >
                <span class="bodyText"
                  >If we stop paying the service or usage fees, can we still use the software?</span
                >
              </div>
              <div
                style="
                  display: inline-block;
                  vertical-align: top;
                  float: right;
                  position: relative;
                  top: -3.313rem;
                "
              >
                <mat-radio-group [(ngModel)]="useWithoutPaying" disabled>
                  <mat-radio-button color="primary" [value]="'YES'">
                    <span class="choiceText">YES</span>
                  </mat-radio-button>
                  <mat-radio-button color="primary" [value]="'NO'" style="margin-left: 1.125rem">
                    <span class="choiceText">NO</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }
  <div style="margin-top: 2.625rem">
    <span class="itProjectHeader" style="font-size: 1.313rem">Page Two</span>
    <div style="display: inline-block; cursor: pointer" (click)="goToEstimatePage()">
      <img style="width: 1.438rem; margin-left: 0.625rem" src="assets/review-edit.svg" />
      <span style="text-decoration: underline; text-underline-offset: 0.15rem">Edit</span>
    </div>
  </div>
  <div style="display: inline-block; margin-top: 1.5rem">
    <div style="width: 23.438rem; height: 6.25rem">
      <div style="display: inline-block; margin-top: 1.125rem">
        <mat-form-field class="itFields" style="width: 19.4rem">
          <input
            readonly="true"
            type="text"
            placeholder="Who will this work benefit?"
            matInput
            [(ngModel)]="department.department"
          />
        </mat-form-field>
      </div>
    </div>
  </div>
  <div style="display: inline-block; margin-top: 1.5rem">
    <div style="width: 38.438rem; height: 6.25rem">
      <div style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem">
        <mat-form-field class="itFields" style="width: 34.563rem">
          <input
            readonly="true"
            type="text"
            placeholder="Building Info (Building Name)"
            matInput
            [(ngModel)]="buildingInfo.BuildingName"
          />
        </mat-form-field>
      </div>
    </div>
  </div>
  @if (!(hardwareOrSoftware === 'Hardware Only' || hardwareOrSoftware === 'O&M Only')) {
    <div style="margin-top: 1.5rem; margin-bottom: 0.5rem">
      <span class="projectScopeHeader">Release Details</span>
    </div>
  }
  @if (!(hardwareOrSoftware === 'Hardware Only' || hardwareOrSoftware === 'O&M Only')) {
    <div style="padding-top: 1.5rem; width: 78rem">
      <div style="width: 78rem; margin-bottom: 1.5rem; text-align: center">
        <span class="projectScopeHeader">Capability and Release Details</span>
      </div>
      <div style="height: 0.1rem; background-color: #f5f5f5"></div>
    </div>
  }
  <div>
    @if (!(hardwareOrSoftware === 'Hardware Only' || hardwareOrSoftware === 'O&M Only')) {
      <div>
        @for (releaseDetail of releaseDetails; track releaseDetail; let i = $index) {
          <div>
            @for (
              capabilityDetail of releaseDetail.capabilityDetails;
              track capabilityDetail;
              let j = $index;
              let jindex = $index
            ) {
              <div>
                <div style="width: 78rem; height: 6.25rem">
                  <div style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem">
                    <mat-form-field class="itFields" style="width: 6rem">
                      <input
                        readonly="true"
                        [(ngModel)]="capabilityDetail.releaseNumber"
                        placeholder="Release #"
                        matInput
                      />
                    </mat-form-field>
                  </div>
                  <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.5rem">
                    <mat-form-field
                      style="
                        background: white;
                        padding-left: 0.4rem;
                        padding-right: 0.4rem;
                        margin-top: 1.125rem;
                        width: 7.1rem;
                        height: 4rem;
                      "
                    >
                      <mat-label>Release Date</mat-label>
                      <input
                        readonly="true"
                        matInput
                        [matDatepicker]="dp"
                        [(ngModel)]="capabilityDetail.releaseDate"
                        style="color: #696969"
                      />
                      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                      <mat-datepicker #dp></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.5rem">
                    <mat-form-field
                      class="itFields"
                      style="width: 19.138rem; cursor: pointer"
                      (click)="openCapabilityDialog(i, jindex)"
                    >
                      <input
                        readonly="true"
                        style="pointer-events: none"
                        [(ngModel)]="capabilityDetail.capabilities"
                        placeholder="Capability"
                        matInput
                      />
                    </mat-form-field>
                  </div>
                  <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.5rem">
                    <mat-form-field
                      class="itFields"
                      style="width: 19.138rem; cursor: pointer"
                      (click)="openCapabilityDialog(i, jindex)"
                    >
                      <input
                        readonly="true"
                        style="pointer-events: none"
                        [(ngModel)]="capabilityDetail.description"
                        placeholder="Detailed Description of Capability"
                        matInput
                      />
                    </mat-form-field>
                  </div>
                  <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.5rem">
                    <mat-form-field class="itFields" style="width: 6rem" [floatLabel]="'always'">
                      <input
                        readonly="true"
                        onkeypress="return event.charCode != 45;"
                        [value]="+capabilityDetail.capitalCost | CurrencyUSD: 'USD' : true : false"
                        placeholder="Capital Cost"
                        matInput
                      />
                    </mat-form-field>
                  </div>
                  <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.5rem">
                    <mat-form-field class="itFields" style="width: 6rem" [floatLabel]="'always'">
                      <input
                        readonly="true"
                        onkeypress="return event.charCode != 45;"
                        [value]="+capabilityDetail.omCost | CurrencyUSD: 'USD' : true : false"
                        placeholder="O&M Cost"
                        matInput
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>
            }
          </div>
        }
        <div style="height: 0.1rem; background-color: #f5f5f5; width: 78rem"></div>
      </div>
    }
    <div style="display: inline-block; margin-top: 1.5rem">
      <div style="width: 23.438rem; height: 6.25rem">
        <div style="display: inline-block; margin-top: 1.125rem">
          <mat-form-field class="itFields" style="width: 19.4rem">
            <input
              readonly="true"
              type="text"
              placeholder="How do you want to distribute cost across business?"
              matInput
              [(ngModel)]="distributeCost"
            />
          </mat-form-field>
        </div>
      </div>
    </div>
    <div style="display: inline-block; margin-left: 1.5rem; margin-top: 1.5rem">
      <div style="width: 23.438rem; height: 6.25rem">
        <div style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem">
          @if (defaultOption) {
            <mat-form-field
              [class.removeElement]="distributeCost === 'Manually'"
              class="itFields"
              style="width: 19.4rem"
            >
              <input
                readonly="true"
                type="text"
                placeholder="Please select one of the default options:"
                matInput
                [(ngModel)]="defaultOption"
              />
            </mat-form-field>
          }
        </div>
      </div>
    </div>
    <div style="margin-top: 1.5rem; margin-bottom: 0.5rem">
      <span class="projectScopeHeader">Allocations</span>
    </div>
    @for (allocation of allocations; track allocation; let i = $index) {
      <div>
        <div
          style="height: 6.25rem"
          [ngStyle]="{
            width: isAllocationFunctionVisible(allocations) ? '90rem' : '78rem',
          }"
        >
          <div style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem">
            <mat-form-field class="itFields" style="width: 21.563rem">
              <input
                readonly="true"
                type="text"
                placeholder="Operating Unit"
                matInput
                [(ngModel)]="allocation.displayOperatingUnit"
              />
            </mat-form-field>
          </div>
          <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.683rem">
            <mat-form-field class="itFields" style="width: 21.563rem">
              <input
                readonly="true"
                [(ngModel)]="allocation.businessUnit"
                placeholder="Business Unit"
                matInput
              />
            </mat-form-field>
          </div>
          <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.683rem">
            <mat-form-field class="itFields" style="width: 9.563rem">
              <input
                readonly="true"
                type="text"
                placeholder="Funding Project ID"
                matInput
                [(ngModel)]="allocation.fundingProjectID.work_order_number"
              />
            </mat-form-field>
          </div>
          <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.683rem">
            <mat-form-field
              [class.hiddenElement]="stateDisabled(allocation)"
              class="itFields"
              style="width: 6.563rem"
            >
              <input
                readonly="true"
                type="text"
                placeholder="State"
                matInput
                [(ngModel)]="allocation.state"
              />
            </mat-form-field>
          </div>
          <div
            [class.removeElement]="
              !isAllocationFunctionVisible(allocations) && !showFunctionField(allocation)
            "
            [class.hiddenElement]="!allocation.function"
            style="display: inline-block; margin-top: 1.125rem; margin-left: 0.683rem"
          >
            <mat-form-field
              [class.hiddenElement]="!allocation.function"
              class="itFields"
              style="width: 6.563rem"
            >
              <input
                readonly="true"
                type="text"
                placeholder="Function"
                matInput
                [(ngModel)]="allocation.function"
              />
            </mat-form-field>
          </div>
          <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.683rem">
            <mat-form-field class="itFields" style="width: 7rem">
              <input
                readonly="true"
                type="number"
                [min]="0"
                onkeypress="return event.charCode != 45;"
                [(ngModel)]="allocation.percentage"
                placeholder="Percentage"
                matInput
              />
            </mat-form-field>
          </div>
        </div>
        <div
          style="height: 0.1rem; background-color: #f5f5f5"
          [ngStyle]="{
            width: isAllocationFunctionVisible(allocations) ? '90rem' : '78rem',
          }"
        ></div>
      </div>
    }
    <div
      [ngStyle]="{
        width: isAllocationFunctionVisible(allocations) ? '90rem' : '78rem',
      }"
    >
      <div
        [class.hiddenElement]="true"
        style="
          padding-left: 1rem;
          padding-top: 1.188rem;
          padding-bottom: 1.313rem;
          cursor: pointer;
          width: 15rem;
        "
      >
        <span style="font-weight: bold; font-size: 1.4rem">&#43;</span>
        <span
          style="padding-left: 0.2rem; text-decoration: underline; text-underline-offset: 0.2rem"
          >Add New Unit Line</span
        >
      </div>
      <div style="position: relative; float: right; margin-top: -4rem; margin-right: 7.6rem">
        <div>
          <span style="color: #696969">Total Allocation:</span>
        </div>
        <div>
          <span style="color: #696969; font-weight: bold">{{ allocationTotal() }}%</span>
        </div>
      </div>
    </div>
    <div style="margin-top: 1.5rem; margin-bottom: 0.5rem">
      <span class="projectScopeHeader">Estimate Details</span>
    </div>
    <div style="padding-top: 1.5rem; width: 78rem">
      <div style="width: 78rem; margin-bottom: 1.5rem; text-align: center">
        <span class="projectScopeHeader">Material Details</span>
      </div>
      <div style="height: 0.1rem; background-color: #f5f5f5"></div>
    </div>
    @for (building of buildings; track building; let i = $index) {
      <div>
        <div style="width: 78rem">
          <div style="padding-left: 1.5rem; padding-top: 1.156rem">
            <span class="projectScopeSubHeader">Building</span>
          </div>
          <div style="display: inline-block; margin-top: 0.625rem; margin-left: 1.5rem">
            <mat-form-field class="itFields" style="width: 36.75rem">
              <input
                readonly="true"
                type="text"
                placeholder="Building Name"
                matInput
                [(ngModel)]="building.buildingName.BuildingName"
              />
            </mat-form-field>
          </div>
          @if (building.materialEstimates && building.materialEstimates.length > 0) {
            <div>
              @if (building.buildingName) {
                <div style="padding-left: 1.5rem; padding-top: 1.156rem">
                  <span class="projectScopeSubHeader"
                    >Materials for {{ building.buildingName.BuildingName }}</span
                  >
                </div>
              }
              @if (!building.buildingName) {
                <div style="padding-left: 1.5rem; padding-top: 1.156rem">
                  <span class="projectScopeSubHeader">Materials for </span>
                </div>
              }
              @for (estimate of building.materialEstimates; track estimate; let j = $index) {
                <div>
                  <div style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem">
                    <mat-form-field class="itFields" style="width: 5.625rem">
                      <input
                        readonly="true"
                        type="text"
                        placeholder="Cost"
                        matInput
                        [(ngModel)]="estimate.cost"
                      />
                    </mat-form-field>
                  </div>
                  <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.438rem">
                    <mat-form-field class="itFields" style="width: 18rem">
                      <input
                        readonly="true"
                        [(ngModel)]="estimate.unitOfPropertyDetails"
                        placeholder="Details"
                        matInput
                      />
                    </mat-form-field>
                  </div>
                  <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.438rem">
                    <mat-form-field
                      class="itFields"
                      style="width: 24.313rem"
                      [class.hiddenElement]="estimate.cost === 'O&M'"
                    >
                      <input
                        readonly="true"
                        type="text"
                        placeholder="Unit of Property Description"
                        matInput
                        [(ngModel)]="estimate.unitOfPropertyDescription"
                      />
                    </mat-form-field>
                  </div>
                  <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.438rem">
                    <mat-form-field class="itFields" style="width: 5.625rem">
                      <input
                        readonly="true"
                        appCurrencyMask
                        [value]="estimate.quantity"
                        placeholder="Quantity"
                        matInput
                      />
                    </mat-form-field>
                  </div>
                  <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.438rem">
                    <mat-form-field class="itFields" style="width: 6rem" [floatLabel]="'always'">
                      <input
                        readonly="true"
                        [value]="+estimate.unitCosts | CurrencyUSD: 'USD' : true : false"
                        placeholder="Unit Costs"
                        matInput
                      />
                    </mat-form-field>
                  </div>
                  <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.438rem">
                    <mat-form-field class="itFields" style="width: 6rem" [floatLabel]="'always'">
                      <input
                        readonly="true"
                        [value]="+estimate.totalCosts | CurrencyUSD: 'USD' : true : false"
                        placeholder="Total Costs"
                        matInput
                      />
                    </mat-form-field>
                  </div>
                </div>
              }
            </div>
          }
          <div style="height: 0.1rem; background-color: #f5f5f5; width: 78rem"></div>
        </div>
      </div>
    }
    <div style="width: 78rem; background-color: #f3fafd">
      <div style="position: relative; float: right; margin-top: 1rem; margin-right: 7.3rem">
        <div>
          <span style="color: #696969">Total Estimated:</span>
        </div>
        <div>
          <span style="color: #696969; font-weight: bold"
            >${{ buildingTotal().toLocaleString('en', { useGrouping: true }) }}</span
          >
        </div>
      </div>
    </div>
    <div style="display: inline-block; padding-top: 1.5rem; width: 78rem; margin-top: 0.688rem">
      <div style="width: 78rem; margin-bottom: 1.5rem; text-align: center">
        <span class="projectScopeHeader">Employee/Contractor Labor Details</span>
      </div>
      <div style="height: 0.1rem; background-color: #f5f5f5"></div>
    </div>
    <div style="width: 78rem; height: 6.25rem; display: inline-block">
      @for (detail of laborDetails; track detail; let i = $index) {
        <div>
          <div style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem">
            <mat-form-field class="itFields" style="width: 12rem">
              <input
                readonly="true"
                type="text"
                placeholder="Work Task"
                matInput
                [(ngModel)]="detail.workTask.workTask"
              />
            </mat-form-field>
          </div>
          <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.5rem">
            <mat-form-field class="itFields" style="width: 39.875rem">
              <input
                readonly="true"
                type="text"
                placeholder="Work Description"
                matInput
                [(ngModel)]="detail.workDescription"
              />
            </mat-form-field>
          </div>
          <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.5rem">
            <mat-form-field class="itFields" style="width: 9rem">
              <input
                readonly="true"
                type="text"
                placeholder="Charge Type"
                matInput
                [(ngModel)]="detail.chargeType"
              />
            </mat-form-field>
          </div>
          <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.438rem">
            <mat-form-field class="itFields" style="width: 6rem" [floatLabel]="'always'">
              <input
                readonly="true"
                [value]="+detail.totalCosts | CurrencyUSD: 'USD' : true : false"
                placeholder="Total Costs"
                matInput
              />
            </mat-form-field>
          </div>
        </div>
      }
      <div style="width: 78rem; background-color: #f3fafd">
        <div style="position: relative; float: right; margin-right: 7rem">
          <div>
            <span style="color: #696969">Total Estimated:</span>
          </div>
          <div>
            <span style="color: #696969; font-weight: bold"
              >${{ laborTotal().toLocaleString('en', { useGrouping: true }) }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <div style="padding-top: 1.5rem; width: 78rem; margin-top: 2.2rem; display: inline-block">
    <div style="width: 78rem; margin-bottom: 1.5rem; text-align: center">
      <span class="projectScopeHeader">Contingency and Other Details (Optional)</span>
    </div>
    <div style="height: 0.1rem; background-color: #f5f5f5"></div>
  </div>
  <div style="width: 78rem; height: 6.25rem; display: inline-block">
    @for (detail of contingencyDetails; track detail; let i = $index) {
      <div>
        <div style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem">
          <mat-form-field class="itFields" style="width: 15rem">
            <input
              readonly="true"
              type="text"
              placeholder="Cost"
              matInput
              [(ngModel)]="detail.cost"
            />
          </mat-form-field>
        </div>
        <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.5rem">
          <mat-form-field class="itFields" style="width: 47.15rem">
            <input
              readonly="true"
              [(ngModel)]="detail.description"
              placeholder="Description"
              matInput
            />
          </mat-form-field>
        </div>
        <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.438rem">
          <mat-form-field class="itFields" style="width: 6rem" [floatLabel]="'always'">
            <input
              readonly="true"
              [value]="+detail.totalCosts | CurrencyUSD: 'USD' : true : false"
              placeholder="Total Costs"
              matInput
            />
          </mat-form-field>
        </div>
      </div>
    }
    <div style="width: 78rem; background-color: #f3fafd">
      <div style="position: relative; float: right; margin-right: 6rem">
        <div>
          <span style="color: #696969">Total Estimated:</span>
        </div>
        <div>
          <span style="color: #696969; font-weight: bold"
            >${{ contingencyTotal().toLocaleString('en', { useGrouping: true }) }}</span
          >
        </div>
      </div>
    </div>
  </div>

  <div
    style="
      padding-top: 1.5rem;
      width: 78rem;
      margin-top: 2.2rem;
      display: inline-block;
      padding-bottom: 1rem;
    "
  >
    <div style="width: 78rem; margin-bottom: 1.5rem; text-align: center">
      <div class="projectScopeHeader pb-1">Cost Summary</div>
      <div style="height: 0.1rem; background-color: #f5f5f5"></div>
    </div>

    <div class="cost-container mb-1 pb-1 grey-border-bottom">
      <div class="cost-column">Total Capital $ by Charge Type</div>
      <div class="cost-column"></div>
      <div class="cost-column">Total O&M $ by Charge Type</div>
      <div class="cost-column"></div>
      <div class="cost-column"></div>
      <div class="cost-column"></div>
    </div>

    <div class="cost-container">
      <div class="cost-column">Internal Labor</div>
      <div class="cost-column">
        ${{ internalCapital().toLocaleString('en', { useGrouping: true }) }}
      </div>
      <div class="cost-column">Internal Labor</div>
      <div class="cost-column">${{ internalOM().toLocaleString('en', { useGrouping: true }) }}</div>
      <div class="cost-column">Capital Cost</div>
      <div class="cost-column">
        ${{ subtotalCapital().toLocaleString('en', { useGrouping: true }) }}
      </div>
    </div>

    <div class="cost-container">
      <div class="cost-column">External Labor</div>
      <div class="cost-column">
        ${{ externalCapital().toLocaleString('en', { useGrouping: true }) }}
      </div>
      <div class="cost-column">External Labor</div>
      <div class="cost-column">${{ externalOM().toLocaleString('en', { useGrouping: true }) }}</div>
      <div class="cost-column">Estimated AFUDC of Project</div>
      <div class="cost-column">
        ${{ estimatedAFUDC().toLocaleString('en', { useGrouping: true }) }}
      </div>
    </div>

    <div class="cost-container">
      <div class="cost-column">Material</div>
      <div class="cost-column">
        ${{ materialCapital().toLocaleString('en', { useGrouping: true }) }}
      </div>
      <div class="cost-column">Material</div>
      <div class="cost-column">${{ materialOM().toLocaleString('en', { useGrouping: true }) }}</div>
      <div class="cost-column">Total Capital Cost</div>
      <div class="cost-column">
        ${{ totalCapitalCost().toLocaleString('en', { useGrouping: true }) }}
      </div>
    </div>

    <div class="cost-container">
      <div class="cost-column">Contingency</div>
      <div class="cost-column">
        ${{ contingencyCapital().toLocaleString('en', { useGrouping: true }) }}
      </div>
      <div class="cost-column">Contingency</div>
      <div class="cost-column">
        ${{ contingencyOM().toLocaleString('en', { useGrouping: true }) }}
      </div>
      <div class="cost-column"></div>
      <div class="cost-column"></div>
    </div>

    <div class="cost-container">
      <div class="cost-column">Other</div>
      <div class="cost-column">
        ${{ otherCapital().toLocaleString('en', { useGrouping: true }) }}
      </div>
      <div class="cost-column">Other</div>
      <div class="cost-column">${{ otherOM().toLocaleString('en', { useGrouping: true }) }}</div>
      <div class="cost-column"></div>
      <div class="cost-column"></div>
    </div>

    <div class="cost-container">
      <div class="cost-column">Subtotal</div>
      <div class="cost-column">
        ${{ subtotalCapital().toLocaleString('en', { useGrouping: true }) }}
      </div>
      <div class="cost-column">Subtotal</div>
      <div class="cost-column">${{ subtotalOM().toLocaleString('en', { useGrouping: true }) }}</div>
      <div class="cost-column">Total O&M Cost</div>
      <div class="cost-column">${{ subtotalOM().toLocaleString('en', { useGrouping: true }) }}</div>
    </div>

    <div class="cost-container">
      <div class="cost-column">Subtotal This Request</div>
      <div class="cost-column">
        ${{
          subtotalCapitalThisRequest().toLocaleString('en', {
            useGrouping: true,
          })
        }}
      </div>
      <div class="cost-column">Subtotal This Request</div>
      <div class="cost-column">
        ${{ subtotalOMThisRequest().toLocaleString('en', { useGrouping: true }) }}
      </div>
      <div class="cost-column">Total Cost (Including AFUDC)</div>
      <div class="cost-column">
        ${{ totalProjectCost().toLocaleString('en', { useGrouping: true }) }}
      </div>
    </div>
  </div>

  <div style="margin-top: 1.5rem; margin-bottom: 0.5rem">
    <span class="projectScopeHeader">Additional Comments to ITPAC (Optional)</span>
  </div>
  <div style="margin-top: 0.688rem">
    <textarea
      [(ngModel)]="additionalComments"
      class="scopeDescriptionTextBox"
      maxlength="255"
    ></textarea>
  </div>
  <div style="margin-top: 1.5rem; margin-bottom: 0.5rem">
    <span class="projectScopeHeader">Attachments</span>
  </div>
  <div style="margin-top: 0.5rem; margin-bottom: 0.5rem">
    <span class="projectScopeNonHeader"
      >Note: Files are for review purposes only. Files uploaded in MMAPS will
      <span style="font-style: italic; font-size: 0.9rem">not</span> be added to PowerPlan.</span
    >
  </div>
  @if (files.length > 0) {
    <div style="width: 48.375rem; display: inline-block; padding-bottom: 1rem">
      <div style="margin-top: 1.5rem">
        <div style="display: inline-block">
          <span class="projectScopeSubHeader" style="font-size: 0.875rem">File Name</span>
        </div>
        <div style="display: inline-block; margin-left: 15rem">
          <span class="projectScopeSubHeader" style="font-size: 0.875rem">Added By</span>
        </div>
        <div style="display: inline-block; margin-left: 10rem">
          <span class="projectScopeSubHeader" style="font-size: 0.875rem">Date</span>
        </div>
        <div
          style="
            display: inline-block;
            height: 0.1rem;
            background-color: #f5f5f5;
            margin-bottom: 0.5rem;
            width: 46rem;
          "
        ></div>
        @for (file of files; track file; let i = $index) {
          <div>
            <div style="display: inline-block; width: 19.05rem">
              <span class="projectScopeNonHeader" style="font-size: 0.875rem">{{
                file.fileName
              }}</span>
            </div>
            <div style="display: inline-block; width: 13.95rem">
              <span class="projectScopeNonHeader" style="font-size: 0.875rem">{{
                file.addedByName
              }}</span>
            </div>
            <div style="display: inline-block">
              <span class="projectScopeNonHeader" style="font-size: 0.875rem">{{ file.date }}</span>
            </div>
            <div style="display: inline-block; margin-top: 1.125rem; margin-right: 0.5rem">
              <img
                style="cursor: pointer; width: 1rem; height: 1rem; padding-left: 3.5rem"
                src="assets/file-download.svg"
                (click)="downloadFile(i)"
              />
            </div>
          </div>
        }
      </div>
    </div>
  }
  <div style="margin-top: 1.5rem; margin-bottom: 0.5rem">
    <span class="projectScopeHeader">Approvers</span>
  </div>
  <div style="padding-top: 1.5rem; width: 78rem; display: inline-block">
    <div style="margin-top: 1.5rem">
      <div style="display: inline-block">
        <span class="projectScopeSubHeader" style="font-size: 0.875rem">Name, Title</span>
      </div>
      <div style="display: inline-block; margin-left: 60.438rem">
        <span class="projectScopeSubHeader" style="font-size: 0.875rem">DOA Authority Amount</span>
      </div>
    </div>
    <div
      style="
        display: inline-block;
        height: 0.1rem;
        background-color: #f5f5f5;
        margin-bottom: 0.5rem;
        width: 75.625rem;
      "
    ></div>
    <div style="padding-bottom: 1.5rem">
      <div style="display: inline-block; width: 65.125rem">
        <span class="projectScopeSubHeader" style="font-size: 0.875rem"
          >{{ itSponsor.givenName }} {{ itSponsor.surname }}, Sponsor</span
        >
      </div>
      <div style="display: inline-block; width: 4.125rem">
        <span class="projectScopeSubHeader" style="font-size: 0.875rem"
          >${{ doaAmounts[0].toLocaleString('en', { useGrouping: true }) }}</span
        >
      </div>
    </div>
    @for (approver of approverList; track approver; let i = $index) {
      <div style="padding-bottom: 1.5rem">
        <div style="display: inline-block; width: 65.125rem">
          @if (approver.givenName && approver.surname && approver.jobTitle) {
            <span class="projectScopeSubHeader" style="font-size: 0.875rem"
              >{{ approver.givenName }} {{ approver.surname }} ({{ approver.mail }}),
              {{ approver.jobTitle }}</span
            >
          }
          @if (approver.givenName && approver.surname && !approver.jobTitle) {
            <span class="projectScopeSubHeader" style="font-size: 0.875rem"
              >{{ approver.givenName }} {{ approver.surname }} ({{ approver.mail }})</span
            >
          }
          @if (!(approver.givenName && approver.surname) && approver.jobTitle) {
            <span class="projectScopeSubHeader" style="font-size: 0.875rem"
              >{{ approver.displayName }} ({{ approver.mail }}), {{ approver.jobTitle }}</span
            >
          }
          @if (!(approver.givenName && approver.surname) && !approver.jobTitle) {
            <span class="projectScopeSubHeader" style="font-size: 0.875rem"
              >{{ approver.displayName }} ({{ approver.mail }})</span
            >
          }
        </div>
        <div style="display: inline-block; width: 4.125rem">
          <span class="projectScopeSubHeader" style="font-size: 0.875rem"
            >${{ doaAmounts[i + 1].toLocaleString('en', { useGrouping: true }) }}</span
          >
        </div>
      </div>
    }
  </div>
  <div style="margin-top: 2.625rem">
    <div class="startOverButton" (click)="goToEstimatePage()">
      <span style="font-size: 0.875rem; color: #00789e">PREVIOUS</span>
    </div>
    <div style="display: inline-block; float: right; padding-bottom: 1.5rem">
      <button class="confirmButton" (click)="submitForm()">
        <span class="confirmText">SUBMIT</span>
      </button>
    </div>
    <div style="display: inline-block; float: right; margin-right: 0.875rem">
      <div class="exitButton" (click)="goToSetupPage()">
        <span class="exitText">EDIT FORM</span>
      </div>
    </div>
    <div style="display: inline-block; float: right; margin-right: 0.875rem">
      <div class="exitButton" (click)="saveDraft()">
        <span class="exitText">SAVE DRAFT</span>
      </div>
    </div>
  </div>
</div>
